import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "@/lib/api";
import { toast } from "sonner";
import { Card } from "@/components/ui/card";
import { Switch } from "@/components/ui/switch";
import { MessageSquareText } from "lucide-react";

// Company setting: Power Ray voice for everything GridForge writes for a person to read.
export function VoiceSetting() {
  const [on, setOn] = useState(null);
  useEffect(() => {
    api.get("/settings/voice").then((r) => setOn(!!r.data.enabled)).catch(() => setOn(null));
  }, []);
  const flip = async (v) => {
    try { const { data } = await api.put("/settings/voice", { enabled: v }); setOn(data.enabled); toast.success(v ? "Power Ray voice is on" : "Power Ray voice is off"); }
    catch (e) { toast.error(e.response?.data?.detail || "Could not change the voice setting"); }
  };
  if (on === null) return null;
  return (
    <Card className="p-4 mb-6 flex items-start gap-3" data-testid="voice-setting">
      <MessageSquareText className="w-5 h-5 text-[#003E87] mt-0.5 shrink-0" />
      <div className="flex-1 min-w-0">
        <div className="text-sm font-semibold text-slate-900">Power Ray voice</div>
        <div className="text-xs text-slate-500">Briefs, emails, sign-off requests and warnings read like a person: short, plain, no filler words and no internal ids. <Link to="/how-to/voice" className="text-[#003E87] hover:underline">How it works</Link></div>
      </div>
      <Switch checked={on} onCheckedChange={flip} data-testid="voice-setting-toggle" />
    </Card>
  );
}
